import React from 'react';

import FieldModal from '../../modals/fieldModal';
import API from '../../../utils/API';

import InputField from '../../../components/inputs/inputField';
import FileUploadInputBox from '../../inputs/fileUploadInputBox';
import FilesUploaderModal from '../../files/filesUploaderModal';

class RenameLocationModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            name: props.location.name,
            map: props.location.map,
            uploadingMapImage: false,
            submitting: false,
            complete: false,
            requiredFields: {
                name: false,
            }
        };
    }

    handleNameChange = (e) => {
        this.setState({
            name: e.target.value
        });
    };

    submit = async () => {
        const { name, map } = this.state;
        const { renameLocation, location, venue } = this.props;
        let valid = true;
        let requiredFields = this.state.requiredFields;
        if (!name) {
            requiredFields.name = true;
            valid = false;
        } else {
            requiredFields = false;
        }

        if (valid) {

            this.setState({ submitting: true })


            await API().patch(`/Organizations/${this.props.orgId}/venues/${venue._id}/locations/${location._id}`, { name, map }).then((res) => {
                if (res.data) {
                    renameLocation(res.data)
                    this.setState({ submitting: false, complete: true })
                }
            });


        } else {

            this.setState({ requiredFields: requiredFields })
        }


    }

    render() {
        const { isOpen, toggle } = this.props;
        const { name, submitting, requiredFields, complete } = this.state;
        return (

            <div>
                <FieldModal
                    size="medium"
                    isOpen={isOpen}
                    modalTitle={"Update Location"}
                    bodyHeaderText={''}
                    bodyDescription={''}
                    bodyContent={() => {
                        return (
                            <div>
                                <InputField
                                    label="Location Name"
                                    required={true}
                                    disabled={complete}
                                    errorTrigger={requiredFields.name}
                                    value={name}
                                    type="name"
                                    onChange={this.handleNameChange}
                                />

                                <FileUploadInputBox
                                    label="Map Image"
                                    onClick={() => {
                                        this.setState({
                                            uploadingMapImage: true,
                                        });
                                    }}
                                    value={this.state.map}
                                    clearFile={() => {
                                        this.setState({
                                            map: '',
                                        });
                                    }}
                                    addText="Map Image"
                                />
                            </div>)
                    }}
                    toggle={toggle}
                    actionButtonLabel={!submitting && !complete ? 'Submit' : submitting && !complete ? 'Updating Location...' : complete ? '' : ''}
                    actionButton={() => this.submit()}
                    actionButtonDisabled={submitting || complete}
                    cancelButtonLabel={complete ? 'Close' : 'Cancel'}


                ></FieldModal>

                <FilesUploaderModal
                    isOpen={this.state.uploadingMapImage}
                    toggle={() => {
                        this.setState({
                            uploadingMapImage: false,
                        });
                    }}
                    eventId={this.props.eventId}
                    links={this.props.event && this.props.event._id ? {
                        getAssets: `Organizations/${this.props.orgId}/events/${this.props.event._id}/assets`,
                        addAssets: `Organizations/${this.props.orgId}/events/${this.props.event._id}/assets`,
                    } : {
                        getAssets: `Organizations/${this.props.orgId}/assets`,
                        addAssets: `Organizations/${this.props.orgId}/assets`,
                    }}
                    orgId={this.props.orgId}
                    addFiles={(fileURL) => {
                        this.setState({
                            uploadingMapImage: false,
                            map: fileURL,
                        });
                    }}
                />
            </div>

        );
    }
}

export default RenameLocationModal;
